import { useId } from 'react';
import Pagination from '../Pagination';

export default function ManagerWorkspace({ view, setView, isEditing, editor, children, query, setQuery, pagination, label }) {
  const id = useId();
  const tabs = ['browse', 'editor'];
  function onKeyDown(event) {
    const current = tabs.indexOf(view);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : event.key === 'ArrowRight' ? (current + 1) % 2 : event.key === 'ArrowLeft' ? (current + 1) % 2 : -1;
    if (next < 0) return;
    event.preventDefault();
    setView(tabs[next]);
    document.getElementById(`${id}-${tabs[next]}-tab`)?.focus();
  }
  return <div className="manager-workspace">
    <div className="manager-tabs" role="tablist" aria-label={`${label} workspace`} onKeyDown={onKeyDown}>
      {tabs.map(tab => <button key={tab} type="button" role="tab" id={`${id}-${tab}-tab`} aria-controls={`${id}-${tab}`} aria-selected={view === tab} tabIndex={view === tab ? 0 : -1} onClick={() => setView(tab)}>{tab === 'browse' ? `Browse ${label}` : isEditing ? 'Edit item' : 'Create new'}</button>)}
    </div>
    <section id={`${id}-editor`} role="tabpanel" aria-labelledby={`${id}-editor-tab`} hidden={view !== 'editor'} tabIndex={0}>{editor}</section>
    <section id={`${id}-browse`} role="tabpanel" aria-labelledby={`${id}-browse-tab`} hidden={view !== 'browse'} tabIndex={0}>
      <div className="manager-toolbar"><label htmlFor={`${id}-search`}>Search {label}<input id={`${id}-search`} type="search" value={query} placeholder={`Find ${label}…`} onChange={event => setQuery(event.target.value)} /></label><span>{pagination.total} items</span></div>
      {pagination.total ? children : <p className="manager-empty">{query ? 'No matches. Try another search.' : `No ${label} yet. Use Create new to add your first item.`}</p>}
      <Pagination {...pagination} label={label} />
    </section>
  </div>;
}
